import { Component, Input, OnInit } from '@angular/core'
import { Venue } from '../domain/Venue'
import { Voucher } from '../domain/Voucher'
import { SKU } from '../domain/SKU'
import { environment } from '../../environments/environment'

@Component({
    selector: 'app-voucher-card',
    templateUrl: './voucher-card.component.html',
    styleUrls: ['./voucher-card.component.sass'],
})
export class VoucherCardComponent implements OnInit {

    @Input() venue!: Venue
    @Input() voucher!: Voucher
    @Input() sku: SKU | null = null
    expiryDateFromNow: Date | null = null
    readonly environment = environment

    readonly width = 340
    readonly waveHeight = 7.0
    readonly waveLength = 90.0
    readonly lineSpacing = 10.0
    wavePathData = ''
    waveLines: number[] = []

    ngOnInit() {
        const now = new Date()
        this.expiryDateFromNow = this.voucher.getExpiryDateFromDate(now)
        this.generateWavePath()
        this.generateLinePositions()
    }

    private generateWavePath() {
        let d = `M 0 0`
        const step = 5
        for (let x = 0; x <= this.width; x += step) {
            const angle = x * (2 * Math.PI / this.waveLength)
            const yOffset = this.waveHeight * Math.sin(angle)
            d += ` L ${x} ${yOffset}`
        }
        this.wavePathData = d
    }

    private generateLinePositions() {
        const maxCardHeight = this.width * 0.628
        let yPos = -this.waveHeight

        while (yPos < maxCardHeight + this.waveHeight) {
            this.waveLines.push(yPos)
            yPos += this.lineSpacing
        }
    }
}
